<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Checkbox, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const calibrationOptionsLegacy = [
		$format('phase_a_range_extender'),
		$format('phase_b_range_extender'),
		$format('phase_c_range_extender'),
		$format('phase_n_range_extender'),
	];

	const calibrationOptionsNewLayout = [
		$format('chart_legend_phase_a', {
			default: 'Phase A',
		}),
		$format('chart_legend_phase_b', {
			default: 'Phase B',
		}),
		$format('chart_legend_phase_c', {
			default: 'Phase C',
		}),
		$format('chart_legend_phase_n', {
			default: 'Phase N',
		}),
	];

	let settings = readDeviceSettings(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;
	const neutralExt = settings?.emeter_n?.range_extender === 2;

	let operatingOptions = [];
	let loading = false;
	let permision = false;
	let localIp = get_local_ip(device.id);
	let cacheOperatingOptions = [];

	$: {
		const calibrationOptions = $showNewLayout
			? calibrationOptionsNewLayout
			: calibrationOptionsLegacy;

		operatingOptions = [];
		cacheOperatingOptions = [];

		calibrationOptions.forEach((option, index) => {
			let selected;
			if (index === 3) {
				selected = neutralExt;
			} else {
				selected = settings.emeters[index].range_extender === 2;
			}
			operatingOptions.push({
				option,
				selected,
				sent: false,
			});
			cacheOperatingOptions.push({ ...operatingOptions[index] });
		});
	}

	const handleSelection = (e) => {
		operatingOptions.forEach((option, index) => {
			if (index === e) {
				option.selected = !option.selected;

				if (
					Object.values({ ...operatingOptions[e] }).toString().length ===
					Object.values({ ...cacheOperatingOptions[e] }).toString().length
				) {
					operatingOptions[e].sent = false;
					cacheOperatingOptions[e].sent = false;
				} else {
					operatingOptions[e].sent = true;
					cacheOperatingOptions[e].sent = true;
				}
			}
		});

		if (operatingOptions.some((x) => x.sent)) {
			permision = true;
		} else {
			permision = false;
		}
	};

	const sentRequest = async () => {
		//TODO need to handle sending only one notification
		if (permision) {
			operatingOptions.forEach(async (value, _index) => {
				let res;
				if (value.sent) {
					let saveIndex = _index === 3 ? 'n' : _index;

					loading = true;
					const selected = operatingOptions[_index].selected;

					if (localIp) {
						res = await localReq(device, `${localIp}/settings/emeter/${_index}`, 'post', {
							range_extender: operatingOptions[_index].selected ? 2 : 1,
						});
					} else {
						res = await postReq(`/device/generic_command`, {
							id: device.id,
							command: `range_extender`,
							payload: JSON.stringify({
								value: operatingOptions[_index].selected ? 2 : 1,
								id: _index,
							}),
						});
					}

					if (res.isok) {
						saveIndex !== 'n'
							? (settings.emeters[_index].range_extender = selected ? 2 : 1)
							: (settings.emeter_n.range_extender = selected ? 2 : 1);
						devices_settings.update_devices_settings(device.id, settings);
						toast.open({
							type: 'success',
							title: $format('setting_scc_saved_toast'),
						});
						cacheOperatingOptions[_index] = { ...operatingOptions[_index] };
					} else {
						operatingOptions[_index] = { ...cacheOperatingOptions[_index] };
						toast.open({ type: 'danger', title: $format('error_global') });
					}
					loading = false;
					operatingOptions[_index].sent = false;
					cacheOperatingOptions[_index].sent = false;
				}
			});
		}
	};
</script>

{#if $showNewLayout}
	<Text styleType="body-small" class="text-bold mb-xs">
		{$format('range_extender_select_phases_title', {
			default: 'Choose the phases with range extender(s):',
		})}
	</Text>
{/if}

{#each operatingOptions as option, _index}
	<Checkbox
		class={`${$showNewLayout && _index === 0 ? '' : 'mt-s'}`}
		style={$showNewLayout && _index !== 0 ? 'margin-top: 12px' : undefined}
		size="m"
		checked={option.selected}
		on:click={() => handleSelection(_index)}
		id={`checkbox-range-extender-${_index}`}>{option.option}</Checkbox
	>
{/each}

<Button
	{loading}
	size="m"
	width="full"
	on:click={sentRequest}
	style={$showNewLayout ? 'margin-top: 16px' : undefined}
>
	{$format('button_save')}
</Button>
